import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LeaveMasterService } from '../../../Model/leave-master.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-leav-form',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule],
  templateUrl: './leav-form.component.html',
  styleUrl: './leav-form.component.scss'
})
export class LeavFormComponent {
  LeaveMasterId: number = 0;
  LeaveName: string = '';
  LeaveType: string = 'Unpaid';
  Gender: string = 'All';
  MaritalStatus: string = 'Unmarried';
  public User: any = null;
  LeaveMasterData: any[] = [];
  CompOff: string = 'No';
  constructor(private leaveService: LeaveMasterService,
    private modalService: NgbModal,
    private sessionService: SessionService,
    private toast: ToastService,
    private route: ActivatedRoute,
    private router: Router,
    protected common: CommonService,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.getLeaveMasterID();
    this.getData();
  }

  getLeaveMasterID() {
    this.route.queryParams.subscribe(params => {
      this.LeaveMasterId = params['LeaveMasterID'];
    });
  }
  getData() {
    this.User = this.sessionService.GetUserDetails();
    const LeaveGetData = {
      SelectType: 1,
      LeaveMasterId: this.LeaveMasterId,
      UserId: this.User.UserId
    }
    console.log(LeaveGetData)
    this.leaveService.LeaveMasterSelect(LeaveGetData).subscribe(
      data => {
        this.LeaveMasterData = Object.values(data.Table);
        this.LeaveName = this.LeaveMasterData[0].LeaveName;
        this.LeaveMasterId = this.LeaveMasterData[0].LeaveMasterID;
        this.LeaveType = this.LeaveMasterData[0].LeaveType 
        this.MaritalStatus = this.LeaveMasterData[0].MaritalStatus 
        this.Gender = this.LeaveMasterData[0].Gender 
        this.CompOff = (this.LeaveMasterData[0].IsCompOff === 0 || this.LeaveMasterData[0].IsCompOff === null) ? 'No' : 'Yes';
      },
      error => {
        console.error('Error:', error);
      }
    );
  }
  async save() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsEdit) {
        if (result) {
          this.Update();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => { });
  }
  onSelectionChange(type: string, event: any) {
    if (type == 'LeaveType') {
      this.LeaveType = event.target.value;
    }
    else if (type == 'Gender') {
      this.Gender = event.target.value;
    }
    else if (type == 'MaritalStatus') {
      this.MaritalStatus = event.target.value;
    }
  }
  Update() {
    this.User = this.sessionService.GetUserDetails();
    const LeaveUpdate = {
      SelectType: 'update',
      LeaveMasterId: this.LeaveMasterId,
      Gender: this.Gender,
      MaritalStatus: this.MaritalStatus,
      LeaveType: this.LeaveType,
      UserId: this.User.UserId,
    };
    console.log('Site data', LeaveUpdate);
    this.leaveService.LeaveMasterUpdate(LeaveUpdate).subscribe(
      data => {
        console.log('API Response:', data);
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          this.close();
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }
      },
      error => {
        console.error('Error:', error);
      });
  }

  close(){
    this.router.navigate(['master/LeaveView']);
  }
}
